module.exports = __webpack_public_path__ + "static/media/logotipo.2372dfc4.svg";